<div #contentOverview class="cv-overview-container scrollable">
	<cv-scope-overview
		*ngIf="overviewUiState === uiState.IS_READY"
		[selectedRule]="selectedRule"
		[photosCollection]="photosCollection"
		[documentOrder]="documentOrder"
		[Addresdescription]="orderDetailModel.description"
		[orderDetailModel]="orderDetailModel"
		(historicalVa)="historicalVal($event)"
	></cv-scope-overview>
	<div class="cv-loading-container" *ngIf="overviewUiState === uiState.IS_LOADING">
		<div class="cv-loading-container__spinner"></div>
	</div>
	<cv-historical-values></cv-historical-values>
</div>
